import React from 'react';

import Text from 'common/components/Text/Text';
import { CommonHash, PersonalStatementQuestion } from 'app/types';
import TextQuestion from './components/TextQuestion';

import styles from './SelfIntroduction.module.scss';

interface CompProps {
  answers: CommonHash;
  setAnswer: (h: CommonHash) => void;
  questions: PersonalStatementQuestion[];
  // setSaveForm: (b: boolean) => void;
}

const OptionalQuestion = ({ answers, setAnswer, questions }: CompProps): React.ReactElement => {
  return (
    <div className={styles.stepContainer}>
      <Text size={24} weight={600} color="primary" inlineStyle={{ marginBottom: '8px' }}>
        Optional Question
      </Text>
      <Text size={14} weight={400} inlineStyle={{ marginBottom: '80px', color: '#727D9B' }}>
        Feel free to skip this part if this is not applicable to you.
      </Text>

      {questions.map((question) => (
        <TextQuestion
          question={question}
          key={question.id}
          answers={answers}
          setAnswer={setAnswer}
        />
      ))}
    </div>
  );
};

export default OptionalQuestion;
